<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.equimentVersion.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headright">
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.equimentVersion.namePh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.equimentVersion.search')}}</el-button>
                </div>
            </div>
            <el-table :data="roles" border class="table" ref="multipleTable" :element-loading-text="$t('pages.equimentVersion.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.equimentVersion.index')"></el-table-column>
                <el-table-column prop="name" :label="$t('pages.equimentVersion.name')"></el-table-column>
                <el-table-column prop="version" :label="$t('pages.equimentVersion.version')"></el-table-column>
                <el-table-column prop="organization" :label="$t('pages.equimentVersion.organization')"></el-table-column>
                <el-table-column prop="date" :label="$t('pages.equimentVersion.modifyTime')" width="140"></el-table-column>
                <el-table-column prop="describe" :label="$t('pages.equimentVersion.describe')" width="300"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'role',
    data: function () {
        return {
            roles: [],
            pageCount: 1,
            multipleSelection: [],
            loading: false,
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            var res = await this.$zybhttp.get('Balance/GetAgreementVersion', {});
            if (res.data.status == 0) {
                var data = res.data.data;
                if (this.query.Field1 != '') {
                    data = data.filter((x) => x.name.indexOf(this.query.Field1) > -1);
                }
                this.roles = data;
                this.pageCount = this.roles.length || 0;
            }
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>

<style>
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
